module.exports = __webpack_public_path__ + "img/51ne.a4480b61.svg";